<div class="logo">
  <img [src]="logoSource" height="90" alt="logo">
</div>